@if (alert.query) {
  <div class="mt-1">
    @if (alert.query.keyword) {
      <span>Keyword: <code>{{alert.query.keyword}}</code><br></span>
    }
    @if (alert.query.person) {
      <span>Users: <code>{{alert.query.person}}</code><br></span>
    }
    @if (alert.query.noperson) {
      <span>Exclude users: <code>{{alert.query.noperson}}</code><br></span>
    }
    @if (alert.query.source) {
      <span>Source: <code>{{alert.query.source}}</code><br></span>
    }
    @if (alert.query.lang) {
      <span>Language: <code>{{alert.query.lang}}</code><br></span>
    }
    @if (alert.query.party) {
      <span>Party: <code>{{alert.query.party}}</code><br></span>
    }
    @if (alert.query.organ) {
      <span>Organ: <code>{{alert.query.organ}}</code><br></span>
    }
    @if (alert.query.commission) {
      <span>Commission: <code>{{alert.query.commission}}</code><br></span>
    }
    @if (alert.query.country) {
      <span>Country: <code>{{alert.query.country}}</code><br></span>
    }
  </div>
}